import { FC, useMemo } from 'react';

import { Button, Modal, Paragraph } from '@smartshell/ui-kit';
import dayjs from 'dayjs';

import s from '../ConfirmationModal.module.scss';
import { IConfirmationModalProps, IDialogData } from '../interfaces';

export const BookingConfirmationModal: FC<IConfirmationModalProps> = ({
  type,
  config,
  onDecline,
  onAccept,
}) => {
  const sortedDialogDate = useMemo<Array<[string, IDialogData[]]>>(
    () =>
      Object.entries(
        config.dialogData?.reduce((acc, item) => {
          if (!acc[item.time]) {
            acc[item.time] = [item];
          } else {
            acc[item.time].push(item);
          }
          return acc;
        }, {} as Record<string, IDialogData[]>) || {}
      ),
    [config.dialogData]
  );

  return (
    <Modal onClose={onDecline} rootId="confirm-root">
      <div className={s.container}>
        <header className={s.title}>{config.title}</header>
        <div>
          {sortedDialogDate?.length !== 0 &&
            sortedDialogDate.map(([key, dialogData]) => (
              <div key={key} className={s.list}>
                <Paragraph size="m" color="secondary">
                  {dayjs(key).format('DD MMMM')}
                </Paragraph>
                <ul className={s.data}>
                  {dialogData?.map((item, index) => (
                    <li key={index} className={s.item}>
                      <span>{item.name}</span>
                      <span>{dayjs(item.time).format('HH:mm')}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
        </div>

        {config.message && <span className={s.message}>{config.message}</span>}
        {type === 'booking' && (
          <div className={s.confirmControls}>
            <Button variant="primary" onClick={onAccept} fullWidth>
              {config.acceptTitle}
            </Button>
            <Button variant="secondary" onClick={onDecline} fullWidth>
              {config.declineTitle}
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
};
